import { apiClient } from 'api/api-client'
import { Roster, RosterFormData, Scorer } from 'types/roster'

type NewRoster = Omit<Roster, 'id'>

export const getRosterForGameInLeague = (teamId: number, leagueId: number, gameId: number) =>
    apiClient.get<Roster[]>(`/rosters/${teamId}/${leagueId}/${gameId}`)

export const addPlayerToRoster = (data: NewRoster) => apiClient.post(`/rosters`, data)

export const deleteRoster = (id: number) => apiClient.delete(`/rosters/${id}`)

export const editRoster = (id: number, data: RosterFormData) => apiClient.patch(`/rosters/${id}`, data)

export const getLeagueScorerTable = (leagueId: number) => apiClient.get<Scorer[]>(`/rosters/scorer-table/${leagueId}`)
